import { Type } from 'class-transformer';
import { ResourceNumericVersionIdentifier } from 'src/app/common/model/resource-id-version-identifier';
import { Zone } from './zone';

export class DepotDTO {
    depotId: number;
    name: string;
    prefix: string;
    vehicles: AssignedVehicleDTO[];
    @Type(() => Zone)
    zone: Zone;
    version: number;
    @Type(() => Date)
    modified: Date;

    getVersionedId(): ResourceNumericVersionIdentifier {
        return new ResourceNumericVersionIdentifier(this.depotId, this.version);
    }

}

export class AssignedVehicleDTO {
    constructor(public readonly id: number, public readonly sideNumber: string, public readonly active: boolean) { }
}
